import { Icon } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { TouchableOpacity, View } from 'react-native';

import { LinkNoDecoration } from 'components/app-header/styled';
import { modalHeaderStyles } from 'components/card-modal-header';
import { Logo } from 'components/logo';
import { useDismissAndReplace } from 'navigation/hooks/use-dismiss-and-navigate';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { routes } from 'utils/routing';

interface IWalmartHeader {
  authzCode?: string | string[] | null;
  disabled?: boolean;
}

export const WalmartHeader = ({ authzCode, disabled = false }: IWalmartHeader) => {
  const { loyaltyUser } = useLoyaltyUser();
  const dismissAndReplace = useDismissAndReplace();
  const router = useRouter();

  if (disabled) {
    return null;
  }

  const control = loyaltyUser && !authzCode && (
    <TouchableOpacity
      onPress={() => (router.canGoBack() ? router.back() : dismissAndReplace(routes.base))}
      testID="modal-back-button"
      hitSlop={15}
    >
      <Icon variant={router.canGoBack() ? 'back' : 'cancel'} />
    </TouchableOpacity>
  );

  return (
    <View style={modalHeaderStyles.headerContainer}>
      <View style={modalHeaderStyles.headerFlexStart}>{router.canGoBack() && control}</View>
      <LinkNoDecoration onPress={() => dismissAndReplace(routes.base)}>
        <Logo />
      </LinkNoDecoration>
      <View style={modalHeaderStyles.headerFlexEnd}>{!router.canGoBack() && control}</View>
    </View>
  );
};
